import { createAsyncThunk } from '@reduxjs/toolkit';

import AuthServiceHelper, {
  IGetPasswordToken,
} from '../../../api/AuthServiceHelper';
import { ApiPaths } from '../../../api/APIPaths';
import ApiDataProvider from '../../../api/ApiDataProvider';

export type TUserSignUp = {
  name: string;
  email: string;
  phoneNumber: string;
  password: string;
  timezone: string;
  curriculum: string;
  grade: string;
  examDate?: number;
};

const apiDataProvider = new ApiDataProvider();

export const userSignUp = createAsyncThunk(
  '/sign-up',
  async (data: TUserSignUp) => {
    return apiDataProvider.post(ApiPaths.signUp, data);
  }
);

export const userSignIn = createAsyncThunk(
  '/sign-in',
  async (data: IGetPasswordToken) => {
    return AuthServiceHelper.getPasswordToken(data);
  }
);

export const getClientCredentialsTokenV2 = createAsyncThunk(
  '/client-credential',
  async (d) => {
    return AuthServiceHelper.getClientCredentialToken();
  }
);
